import { render, staticRenderFns } from "./JoszakiDataTable.vue?vue&type=template&id=9951349e"
import script from "./JoszakiDataTable.vue?vue&type=script&lang=js"
export * from "./JoszakiDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports